import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
  overflow:scroll;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
}
.materials {
  margin-left:20px;
}

button{
  margin-top: 20px;
  margin-bottom: 20px;
}
main{
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
  border:0px;
}

.material-option{
  margin-top: 10px;
}
.material-option>img{
  width: auto;
  height: auto;
  max-width: 15vw;
  min-width: 75px;  
  max-height: 15vh;
  min-height: 50px;
}

`